export default "__VITE_ASSET__VFAnWTNv__"